<template>
<div>
	<div class="wrap" v-if="isMobile">
		<div class="mnews_list">
			<ul>
				<li v-for="item in noticeArr" v-bind:key="item.ID" >
					<router-link :to="'/details/'+item.ID" >{{item.Title}}</router-link>
					<span>{{formatDate(item.CreateDate)}}</span>
				</li>
			</ul>

			<div class="pagination">
					<el-pagination background layout="prev, pager, next , jumper" :hide-on-single-page="true" :pager-count=5 :total="totalCount" :page-size="pageSize" :current-page="pageIndex" @current-change="handleCurrentChange">
					</el-pagination>
			</div>
		</div>
	</div>
	<div v-else class="content">
            <div class="news_list">
               <dl v-for="item in noticeArr" v-bind:key="item.ID">
                   <dd><router-link :to="'/details/'+item.ID" active-class="hover"><img :src="item.ImgUrl"  /></router-link></dd>  
                   <dt>
                       <h2><router-link :to="'/details/'+item.ID" active-class="hover">{{item.Title}}</router-link></h2><span class="fr">{{formatDate(item.CreateDate)}}</span>
                       <p><router-link :to="'/details/'+item.ID" active-class="hover">{{item.briefContent}}</router-link></p>
                   </dt>
               </dl>


			   <div class="pagination">
				<el-pagination background layout="prev, pager, next , jumper" :hide-on-single-page="true" :pager-count=5 :total="totalCount" :page-size="pageSize" :current-page="pageIndex" @current-change="handleCurrentChange">
				</el-pagination>
				</div>
            </div>
	</div>
</div>
</template>
<style scoped>

.mnews_list{ background:#fff;  float:left; margin-bottom:2.4rem;padding:0 4%; width:92%; padding-bottom:2rem; padding-top:1rem;}
.mnews_list ul{ overflow: hidden; margin-bottom:2rem;}
.mnews_list li{cursor: pointer; margin-top:1rem; height:1.4rem;line-height:1.4rem;display:flex; width:100%;}
.mnews_list li span{overflow: hidden; color: #aaa;   font-size:1.2rem;  display:block; width:35%; text-align: right; }
.mnews_list a{width:65%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;color: #747474;  font-size:1.2rem; }
.mnews_list a:hover{color:#1890ff;}

.news_list{ margin-top:20px;background:#fff; padding:12px 0;margin-bottom: 28px; padding-bottom: 54px;}
.news_list dl{  padding:12px 24px; overflow:hidden;}
.news_list dl:hover{background:#eee;}
.news_list dd{float:left; width:25%; padding-right:3%; vertical-align:middle; height:152px; overflow: hidden;}
.news_list img{ width:100%;}
.news_list dt{float:left; width:72%;padding-top:10px; }
.news_list h2{font-size: 18px; float:left;}
.news_list h2{color: #2a2a2a;}
.news_list span{font-size: 14px;color: #aaa;}
.news_list  p{clear:both; height: 72px;font-size: 14px; line-height: 24px; overflow: hidden; text-overflow: ellipsis; padding-top:16px; text-align:justify;}
.news_list  p a{color: #747474; }



</style>
<script>   
	export default {
		name: 'information',
		methods: {
			handleCurrentChange(val){
				this.pageIndex=val;
			    this.list();
			},
			list(){
				const self = this;
				self.http.ajaxGet("NewsList?PageSize="+self.pageSize+"&PageIndex="+self.pageIndex+"&Type=2",function(res){
                if(res.ReturnCode == 1){
					self.noticeArr=res.Result;
					self.totalCount=parseInt(res.Message);

                }else{
                    self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
                }	
                },function(err){
                    self.$alert(err, '错误', {confirmButtonText: '确定'});
                })
			},
			formatDate(date){
				return this.http.dateFormat1("yyyy-MM-dd",date);
        	}
		},
		data() {
			return {
				pageIndex:1,
				totalCount:0,
			    noticeArr:[]              //资讯
			}
		},
		computed:{
			pageSize(){
				return this.$store.getters.pageSize;
			},
			isMobile(){
				return this.common.isMobile();
			}
		},
		mounted: function () {
			this.list();
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/information.vue